import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@src/api/config";
import { AccType } from "@src/components/common/filters";
import { ApiReturn } from "@src/redux/payments/payments.types";
import { AppDispatch, RootState } from "@src/redux/store";

export const getGeneralSuggestions = createAsyncThunk<
  ApiReturn,
  AccType,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>("general-suggestions/get", async (params: AccType, thunkApi) => {
  const state = thunkApi.getState();
  const products = state.products as { productSelected: { value: any } };
  const businessLines = state.businessLines as {
    businessLineSelected: { id: any };
  };
  const business_line = businessLines.businessLineSelected.id;
  const product = products.productSelected.value;
  const finalParams = { ...params, product, business_line };

  const response = await api.post(`api/general-suggestions`, finalParams);
  return {
    data: response.data,
    params
  };
});